import React from 'react';
import { Box, Button, Typography } from '@mui/material';

// Shown on a page (or section) the company's plan doesn't cover - it stays
// viewable, read-only. "Upgrade" opens the plan / add-on prompt.
const PlanUpgradeBar: React.FC<{ onUpgrade: () => void; sx?: object }> = ({ onUpgrade, sx }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, px: 2, py: 1, borderRadius: 2, background: 'var(--color-container-background)', ...sx }}>
        <Typography sx={{ fontSize: 13.5, fontWeight: 600 }}>Please upgrade to access</Typography>
        <Button
            size="small"
            variant="contained"
            onClick={onUpgrade}
            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 2, boxShadow: 'none', background: 'var(--color-primary)' }}
        >
            Upgrade
        </Button>
    </Box>
);

export default PlanUpgradeBar;
